import { getSystemEnv } from '@/utils/env'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import KmlDataLayer from './KmlDataLayer'
import { FunctionComponent } from 'react'

export interface LatLong {
  id?: number
  lat: number
  lng: number
}

interface Props {
  kmlUrl: string
  center: LatLong
  zoom: number
  userLocation?: { lat: number, lng: number } | null
}

const containerStyle = {
  width: '100%',
  height: '100%'
}

const GoogleMapComponent: FunctionComponent<Props> = ({ kmlUrl, center, zoom, userLocation }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: getSystemEnv().GOOGLE_MAP_API_KEY
  })

  return isLoaded && (loadError == null)
    ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
      >
        <KmlDataLayer url={kmlUrl} />
        {(userLocation != null) && (
          <Marker
            position={userLocation}
            zIndex={1000}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 7,
              fillColor: '#4436fa',
              fillOpacity: 1,
              strokeColor: 'white',
              strokeWeight: 2
            }}
          />
        )}
      </GoogleMap>
      )
    : (
      <></>
      )
}

export default GoogleMapComponent
